import * as Yup from 'yup'

export function ValidateForm(values) {
    return Yup.object().shape({
        account_number: Yup.string().required('This field is required'),
        account_name: Yup.string().required('This field is required'),
        short_name: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        address: Yup.array(Yup.object({
            pharmacy: Yup.string().required('This field is required'),
            reference: Yup.string().required('This field is required'),
            phone: Yup.string().required('This field is required'),
            line_1: Yup.string().required('This field is required'),
            country: Yup.string().required('This field is required'),
        })).required("This field is required"),

        activities: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),

    });
}

export function SingleValidateForm(values) {
    return Yup.object().shape({
        account_number: Yup.string().required('This field is required'),
        account_name: Yup.string().required('This field is required'),
        short_name: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        address: Yup.array(Yup.object({
            phone: Yup.string().required('This field is required'),
            line_1: Yup.string().required('This field is required'),
            country: Yup.string().required('This field is required'),
        })).required("This field is required"),

        activities: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),

    });
}


export function ValidateInvite(values) {
    return Yup.object().shape({
        account_number: Yup.string().required('This field is required'),
        account_name: Yup.string().required('This field is required'),
        short_name: Yup.string().required('This field is required'),
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        subject: Yup.string().required('This field is required'),
        message: Yup.string().required('This field is required'),
    });
}
